// export const EVENT_TYPE = {
//   webinar: 'Webinar',
//   training: 'Pelatihan',
//   'study-consultation': 'Kajian dan Konsultasi',
// };

export const EVENT_TYPE: { [key: string]: string } = {
  webinar: 'Webinar',
  training: 'Training',
  'study-consultation': 'Study Consultation',
};